import React, { useState } from 'react';
import PropTypes from 'prop-types';
import i18n from '@/utils/i18n';
import { useMutation } from '@apollo/client';
import {
  Sheet,
  Title,
  AllergenList,
  Allergen,
  AllergenIcon,
  Icon,
  AllergenLabel,
  OKButton,
  AllergenTextIcon,
} from './styled';
import Modal from '../../../../../../components/Modal';
import {
  getAllergensAndAdditives,
  allergensAndAdditives,
} from '@/utils/allergen';
import {
  updateExtra as updateExtraMutation,
  updateProduct as updateProductMutation,
} from '../../../../../../graphql/mutations';
import { productCategories as productCategoriesQuery } from '../../../../../../graphql/queries';

function AllergenModal({ productId, parentProductId, allergens, onClose }) {
  const productAllergens = getAllergensAndAdditives(allergens || []).map(
    (a) => a.key,
  );

  const [selectedKeys, setKeys] = useState(productAllergens || []);
  // sort() mutates selectedKeys and do this way instead of sorting with useEffect(sort, [selectedKeys])
  const touched =
    JSON.stringify(productAllergens) !==
    JSON.stringify([...selectedKeys].sort());

  const [updateProduct, { loading: updating }] = useMutation(
    updateProductMutation,
  );
  const [updateExtra, { loading: updatingExtra }] =
    useMutation(updateExtraMutation);

  function handleChange(key) {
    if (selectedKeys.includes(key)) {
      setKeys(selectedKeys.filter((k) => k !== key));
    } else {
      setKeys([...selectedKeys, key]);
    }
  }

  function handleSave() {
    if (parentProductId) {
      // update as extra
      updateExtra({
        variables: {
          product_id: parentProductId,
          extra_id: productId,
          payload: { allergens: selectedKeys.length > 0 ? selectedKeys : null },
        },
        refetchQueries: [
          {
            query: productCategoriesQuery,
            variables: {
              id: 'str_u33d8ybdt8ep',
              filter: 'ALL',
            },
          },
        ],
        update: () => {
          onClose(selectedKeys);
        },
      });
    } else {
      updateProduct({
        variables: {
          id: productId,
          product: { allergens: selectedKeys.length > 0 ? selectedKeys : null },
        },
        refetchQueries: [
          {
            query: productCategoriesQuery,
            variables: {
              id: 'str_u33d8ybdt8ep',
              filter: 'ALL',
            },
          },
        ],
        update: () => {
          onClose(selectedKeys);
        },
      });
    }
  }

  return (
    <Modal onClose={() => onClose(allergens)}>
      <Sheet>
        <Title>{i18n.t('Legacy:allergyModal')}</Title>
        <AllergenList>
          {allergensAndAdditives.map((allergen) => (
            <Allergen
              key={allergen.key}
              onClick={() => handleChange(allergen.key)}
            >
              <AllergenIcon
                selected={selectedKeys.some((key) => key === allergen.key)}
              >
                {allergen.icon ? (
                  <Icon src={allergen.icon} />
                ) : (
                  <AllergenTextIcon>{allergen.key}</AllergenTextIcon>
                )}
              </AllergenIcon>
              <AllergenLabel>{allergen.description}</AllergenLabel>
            </Allergen>
          ))}
        </AllergenList>
        <OKButton
          disabled={!touched || updating}
          loading={updating || updatingExtra}
          onClick={handleSave}
        >
          {i18n.t('Menu:save')}
        </OKButton>
      </Sheet>
    </Modal>
  );
}

AllergenModal.propTypes = {
  productId: PropTypes.string.isRequired,
  allergens: PropTypes.array,
  onClose: PropTypes.func.isRequired,
  parentProductId: PropTypes.string,
};

AllergenModal.defaultProps = {
  allergens: [],
  parentProductId: null,
};

export default AllergenModal;
